import ContentRoutes from 'ContentUtils/Routes';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { fetchFolders } from 'email-management-lib/refactor/actions/manage/general';
import EmailFolderSelectTree from 'email-management-lib/refactor/components/shared/EmailFolderSelectTree';
import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  const {
    onSelect
  } = ownProps;
  const foldersState = state.getIn(['entities', 'folders']);
  return {
    folders: foldersState.getData(),
    onSelect,
    hasEverLoadedFolders: foldersState.hasEverLoaded(),
    isLoading: !foldersState.hasEverLoaded() || foldersState.isLoading()
  };
};
const mapDispatchToProps = {
  fetchFoldersContext: fetchFolders
};
class EmailFolderSelectTreeContainer extends Component {
  componentDidMount() {
    const {
      hasEverLoadedFolders,
      fetchFoldersContext
    } = this.props;
    if (!hasEverLoadedFolders) {
      fetchFoldersContext();
    }
  }
  renderEmptyState() {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link
        },
        message: "email-management.table.moveToFolderModal.emptyState_jsx",
        options: {
          link: `${ContentRoutes.emailDashboard()}/folder`
        }
      })
    });
  }
  render() {
    const {
      folders,
      isLoading
    } = this.props;
    if (isLoading) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 100
      });
    }
    if (!folders.size) {
      return this.renderEmptyState();
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.table.moveToFolderModal.body"
        })
      }), /*#__PURE__*/_jsx(EmailFolderSelectTree, Object.assign({}, this.props))]
    });
  }
}
EmailFolderSelectTreeContainer.propTypes = {
  fetchFoldersContext: PropTypes.func.isRequired,
  // @ts-expect-error Type 'typeof Map' provides no match for the signature 'new (...args: any[]): unknown'.
  folders: PropTypes.instanceOf(ImmutableMap).isRequired,
  hasEverLoadedFolders: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
  selectedFolderId: PropTypes.number
};
export default connect(mapStateToProps, mapDispatchToProps)(EmailFolderSelectTreeContainer);